var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/startup.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"content\">\r\n";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"language");
frame.set("languageID", t_1, true);
if(frame.topLevel) {
context.setVariable("languageID", t_1);
}
if(frame.topLevel) {
context.addExport("languageID", t_1);
}
output += "\r\n";
if(runtime.contextOrFrameLookup(context, frame, "languageID") == "fr") {
output += "\r\n    ";
var t_2;
t_2 = "en";
frame.set("languageID", t_2, true);
if(frame.topLevel) {
context.setVariable("languageID", t_2);
}
if(frame.topLevel) {
context.addExport("languageID", t_2);
}
output += "\r\n";
;
}
output += "\r\n    <div style=\"max-width: 800px; padding: 10px;\">\r\n        <!--<h3>Welkom bij ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"product"), env.opts.autoescape);
output += ", ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"username"), env.opts.autoescape);
output += "!</h3> -->\r\n        <h3>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"WelcomeMessage"), env.opts.autoescape);
output += ", ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"username"), env.opts.autoescape);
output += "!</h3>\r\n        <!-- <p>Test vertalingen inladen: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"NoRowsFound"), env.opts.autoescape);
output += "</p> -->\r\n\r\n        <h2>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"AssistanceMessage"), env.opts.autoescape);
output += "</h2>\r\n\r\n        <p>\r\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"SupportMessage"), env.opts.autoescape);
output += "\r\n        </p>\r\n\r\n        <div class=\"startup-row\">\r\n            <i class=\"fab fa-youtube fa-lg\" aria-hidden=\"true\"></i>\r\n            <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"productDomain"), env.opts.autoescape);
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "languageID"), env.opts.autoescape);
output += "/support/webinars\" target=\"_blank\">\r\n                <button class=\"button button-default pull-right\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"MoreInfo"), env.opts.autoescape);
output += "</button>\r\n            </a>\r\n            <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"TutorialsMessage"), env.opts.autoescape);
output += "</span>\r\n        </div>\r\n\r\n        <div class=\"startup-row\">\r\n            <i class=\"fa fa-book fa-lg\" aria-hidden=\"true\"></i>\r\n            <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"productDomain"), env.opts.autoescape);
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "languageID"), env.opts.autoescape);
output += "/support/manual/introduction\" target=\"_blank\">\r\n                <button class=\"button button-default pull-right\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"MoreInfo"), env.opts.autoescape);
output += "</button>\r\n            </a>\r\n            <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ManualsMessage"), env.opts.autoescape);
output += "</span>\r\n        </div>\r\n\r\n        <div class=\"startup-row\">\r\n            <i class=\"fa fa-envelope fa-lg\" aria-hidden=\"true\"></i>\r\n            <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"productDomain"), env.opts.autoescape);
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "languageID"), env.opts.autoescape);
output += "/contact\" target=\"_blank\">\r\n                <button class=\"button button-default pull-right\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"MoreInfo"), env.opts.autoescape);
output += "</button>\r\n            </a>\r\n            <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"SupportDepartmentMessage"), env.opts.autoescape);
output += "</span>\r\n        </div>\r\n\r\n        <hr>\r\n\r\n        <h2>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"GeneralInfo"), env.opts.autoescape);
output += "</h2>\r\n\r\n        <div class=\"startup-row\">\r\n            <i class=\"fa fa-globe fa-lg\" aria-hidden=\"true\"></i>\r\n            <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"productDomain"), env.opts.autoescape);
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "languageID"), env.opts.autoescape);
output += "\" target=\"_blank\">\r\n                <button class=\"button button-default pull-right\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"MoreInfo"), env.opts.autoescape);
output += "</button>\r\n            </a>\r\n            <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"WebsiteMessage"), env.opts.autoescape);
output += "</span>\r\n        </div>\r\n    </div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/startup.html"] , dependencies)